module.exports = __webpack_public_path__ + "static/img/xczx.ceb4367.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xczx.png
// module id = RBya
// module chunks = 0